<ul class="aw-tab-nav">
  <li class="aw-tab-nav__item" 
    *ngFor="let tab of tabs; let i = index" 
    (click)="selectTab(tab, i)" 
    [class.aw-tab-nav__item--selected]="tab.active"
    [style.width]="tabNavWidth">
    {{tab.title}}
  </li>
</ul>
<ng-content></ng-content>